import React from 'react'
import { FooterImport } from './Import'
const { RoutesMap, Logo, FaFacebookF, FaInstagram, FaLinkedinIn, FaPinterestP, Globe, Mail, MapPin, PhoneCall, gallery_1, gallery_2, gallery_3, Link } = FooterImport;

export default function LandingPageFooter() {
    return (
        <>
            <div className="footer">
                <div className="container">
                    <div className="footer_main">
                        <div className="row">

                            <div className="col-lg-3 col-md-6 col-12">
                                <div className="footer-logo-area">
                                    <img src={Logo} alt="logo" />

                                    <p>We are committed to creating a platform where business leaders, innovators, and professionals
                                        can come together to exchange ideas</p>

                                    <div className='d-flex align-items-center'>
                                        <div className='social-icons' onClick={() => window.open("https://www.facebook.com/share/1CAihyeW9D/", "_blank")}>
                                            <FaFacebookF size={18} />
                                        </div>
                                        <div className='social-icons' onClick={() => window.open("https://www.instagram.com/walkrunrideincelebration?igsh=aXk1dm5wazRhMGVy", "_blank")}>
                                            <FaInstagram size={18} />
                                        </div>
                                        {/* <div className='social-icons'>
                                            <FaLinkedinIn size={18} />
                                        </div> */}
                                        <div className='social-icons' onClick={() => window.open("https://pin.it/70sRTY5XL", "_blank")}>
                                            <FaPinterestP size={18} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-2 col-md-6 col-12">
                                <div className="link-content">
                                    <h3>Quick Links</h3>
                                    <div className='custom_list'>
                                        <ul>
                                            <li><Link to={RoutesMap.ABOUT_US.path}>About Us</Link></li>
                                            <li><Link to={RoutesMap.TERMS_CONDITIONS.path}>Terms & Conditions</Link></li>
                                            <li><Link to={RoutesMap.PRIVACY_POLICY.path}>Privacy Policy</Link></li>
                                            <li><Link to={RoutesMap.REFUND_CANCELLATION.path}>Refund & Cancellation</Link></li>
                                            <li><Link to={RoutesMap.SHIPPING_DELIVERY.path}>Shipping & Delivery</Link></li>
                                            <li><Link to={RoutesMap.HELP_SUPPORT.path}>Help & Support</Link></li>
                                            {/* <li><a href="">About Us</a></li>
                                            <li><a href="">Our Blogs</a></li>
                                            <li><a href="">Event Listing</a></li>
                                            <li><a href="">Pricing Plan</a></li>
                                            <li><a href="">Contact Us</a></li> */}
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 col-12">
                                <div className="link-content ps-3">
                                    <h3>Contact Us</h3>
                                    <div className='custom_list'>
                                        <ul>
                                            <li>
                                                <a href="tel:+918447157365">
                                                    <PhoneCall style={{ margin: '0 8px 0 0' }} />
                                                    +91 84471-57365
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <MapPin style={{ margin: '0 8px 0 0' }} />
                                                    Guwahati, Assam
                                                </a>
                                            </li>
                                            <li>
                                                <a href="mailto:eventifyevent@gmail.com">
                                                    <Mail style={{ margin: '0 8px 0 0' }} />
                                                    hello@wrricconnect.org
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <Globe style={{ margin: '0 8px 0 0' }} />
                                                    wrricconnect.com
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-12">
                                <div className="link-content footer-social-box ps-3">
                                    <h3>Our Recent Event Gallery</h3>

                                    <div className="row">
                                        <div className="col-lg-4 col-md-4 col-4">
                                            <div className="img1">
                                                <img src={gallery_1} alt="" />
                                                <div className="icons">
                                                    <a href="#"><FaInstagram size={25} /></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-4 col-4">
                                            <div className="img1">
                                                <img src={gallery_2} alt="" />
                                                <div className="icons">
                                                    <a href="#"><FaInstagram size={25} /></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-4 col-4">
                                            <div className="img1">
                                                <img src={gallery_3} alt="" />
                                                <div className="icons">
                                                    <a href="#"><FaInstagram size={25} /></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-4 col-4">
                                            <div className="img1">
                                                <img src={gallery_1} alt="" />
                                                <div className="icons">
                                                    <a href="#"><FaInstagram size={25} /></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-4 col-4">
                                            <div className="img1">
                                                <img src={gallery_2} alt="" />
                                                <div className="icons">
                                                    <a href="#"><FaInstagram size={25} /></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-4 col-4">
                                            <div className="img1">
                                                <img src={gallery_3} alt="" />
                                                <div className="icons">
                                                    <a href="#"><FaInstagram size={25} /></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="copyright">
                                <p>&copy; Copyright 2025 - WRRIC Arokkiyam Foundation. All Right Reserved</p>
                                <p>Developed by <u className='text_orange' style={{ cursor: 'pointer' }} onClick={() => window.open('https://www.techlene.com/', '_blank')}>Techlene Software Solutions Pvt. Ltd.</u></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}